import { PublishedTableOfContents } from '~/types/content'
import { isPublishedDocumentContent } from '~/utils/shared/content'

export const NESTING_ITEM_MARGIN = 18

export const extractProductPathFromUrl = (pathname: string) => [pathname.split('/')[2], pathname.split('/')[3]].join('/')

export const findPathToActiveItem = (tableOfContents: PublishedTableOfContents[], pathname: string) => {
  const path: string[] = []
  const productPath = extractProductPathFromUrl(pathname)

  const traverse = (items) => {
    for (const item of items) {
      path.push(item.tableOfContentsId)
      if (item.path === productPath) {
        return true
      }
      if (item.children && traverse(item.children)) {
        return true
      }
      path.pop()
    }
    return false
  }

  traverse(tableOfContents)

  return path
}

export const flattenTocIds = (tocItems: PublishedTableOfContents[]): string[] => tocItems.reduce((flatIds, item) => {
  flatIds.push(item.tableOfContentsId)

  if (isPublishedDocumentContent(item) && item.children?.length > 0) {
    flatIds = flatIds.concat(flattenTocIds(item.children))
  }

  return flatIds
}, [] as string[])

export const calculateNestedMargin = (level: number, isMobile?: boolean) => {
  if (level === 0) {
    return 0
  }
  const maxMobileLevel = 5
  if (isMobile && level > maxMobileLevel) {
    return 8 + maxMobileLevel * NESTING_ITEM_MARGIN
  }
  return 8 + level * NESTING_ITEM_MARGIN
}